import { memo, ReactNode } from 'react';
import { classnames } from '@/libs/utils';

interface SelectableOptionCardProps {
  isActive: boolean;
  disabled?: boolean;
  preventNativeDisable?: boolean;
  onClick: () => void;
  trackingId?: string;
  ariaLabel: string;
  tooltipAnchorId?: string;
  label: string;
  children: ReactNode;
  padding?: string;
}

function SelectableOptionCard({
  isActive,
  disabled = false,
  preventNativeDisable = false,
  onClick,
  trackingId,
  ariaLabel,
  tooltipAnchorId,
  label,
  children,
  padding = 'p-2.5 pb-2'
}: SelectableOptionCardProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={isActive}
      aria-label={ariaLabel}
      data-tooltip-id={tooltipAnchorId}
      disabled={disabled && !preventNativeDisable}
      onClick={onClick}
      data-tracking-id={trackingId}
      className={classnames(
        'flex w-full flex-col items-start gap-2 rounded-[10px] border-[1.5px] bg-white transition-colors',
        padding,
        isActive
          ? 'border-slate-900 outline outline-2 outline-offset-[-2px] outline-slate-900'
          : 'border-slate-200 hover:border-slate-300',
        disabled ? 'cursor-not-allowed opacity-30' : 'cursor-pointer'
      )}
    >
      {children}
      <p className="w-full text-center text-xs font-medium leading-[18px] text-slate-900">{label}</p>
    </button>
  );
}

export default memo(SelectableOptionCard);
